<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">{{ $t('login.impersonate-login') }}</h5>
                  <p>{{ $t('login.sign-in') }}</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/logo/ct-logo.webp"
                alt class="img-fluid" />
              </div>
            </div>
          </div>
          <div class="card-body pt-0 m-2">
            <b-form class="p-2" @submit.prevent="tryToLogIn">
              <b-form-group :label="$t('login.username')" label-for="user-username">
                <b-form-input
                  name="user-username"
                  id="user-username"
                  v-model="$v.username.$model"
                  type="text"
                  :state="validateField('username')"
                ></b-form-input>
                <b-form-invalid-feedback>
                  {{ $t("validation.required") }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="input-group-2" :label="$t('login.password')" label-for="user-password">
                <b-form-input
                  name="user-password"
                  id="user-password"
                  v-model="$v.password.$model"
                  type="password"
                  :state="validateField('password')"
                ></b-form-input>
                <b-form-invalid-feedback>
                  {{ $t("validation.required") }}
                </b-form-invalid-feedback>
              </b-form-group>
              <b-alert :show="showErrors" variant="danger">{{ $t("login-error") }}</b-alert>
              <div class="mt-3">
                <b-button type="submit" variant="primary" class="btn-block">{{ $t('menuitems.authentication.list.login') }}</b-button>
              </div>>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
    </div>
  </Layout>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import appConfig from "@/app.config";
import Layout from "@/router/layouts/auth";
import { impersonateAuthService } from '@/helpers/services/auth/impersonateAuthService';
import { toastrService } from '@/helpers/services/notification/toastrService';


/**
 * Login component
 */
export default {
  page: {
    title: "Login",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout },
  props: {
    companyId: {
      type: String,
      required: true,
    },
    toastrMessage: {
      type: String,
    },
    toastrType: {
      type: String,
    },
  },
  data() {
    return {
      username: process.env.LOGIN_USERNAME,
      password: process.env.LOGIN_PASSWORD,
      showErrors: false,
    };
  },
  validations: {
    username: { required },
    password: { required },
  },
  methods: {
    tryToLogIn() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      const { username, password } = this;

      impersonateAuthService.login(this.companyId, username, password)
      .then(loginSuccessful => {
        if (loginSuccessful === false) {
          this.showErrors = true;
        }
      });
    },
    showToastrMessage(toastrType, toastrMessage) {
      switch (toastrType) {
        case toastrService.ERROR_TYPE:
          toastrService.showError(toastrMessage);
          break;
        case toastrService.SUCCESS_TYPE:
          toastrService.showSuccess(toastrMessage);
          break;
        default:
          break;
      }
    },
    validateField(name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
  },
  created() {
    this.showToastrMessage(this.toastrType, this.toastrMessage);
  },
};
</script>